/// <amd-module name="TFS/Admin/Common/Controls/UsersListDialog/UsersListComponent" />
import React = require("react");
import { ICustomIdentityRef } from "TFS/Admin/Common/Contracts/CustomIdentityRef";
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRefWithEmail } from "VSS/Platform/Contracts/WebApi";
import { getIdentityImageUrl } from "VSS/Platform/Identity";
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { IListItemDetails, List, ListItem, renderListItem, ScrollableList } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { VssPersona, VssPersonaSize } from "VSSUI/VssPersona";

export interface IUsersListComponentProps {
    pageContext?: IVssPageContext;
    users: IdentityRefWithEmail[] | ICustomIdentityRef[];
    avatarSize?: VssPersonaSize;
    canDeleteMember?: boolean;
    onDeleteMember?: (selectedItem: ICustomIdentityRef) => void;
}

export class UsersListComponent extends React.Component<IUsersListComponentProps> {
    public render(): JSX.Element {
        return (
            <ScrollableList
                itemProvider={new ArrayItemProvider<IdentityRefWithEmail | ICustomIdentityRef>(this.props.users)}
                renderRow={this._renderUserList}
                className="width-100"
            />
        );
    }

    private _renderUserList = (
        index: number,
        item: IdentityRefWithEmail | ICustomIdentityRef,
        details: IListItemDetails<IdentityRefWithEmail | ICustomIdentityRef>
    ): JSX.Element => {
        return (
            <ListItem key={"list-item-" + index} index={index} details={details}>
                <div className="user-info-details flex-row flex-center">
                    <VssPersona
                        identityDetailsProvider={{
                            getIdentityImageUrl: (size: number): string | undefined => {
                                return item.imageUrl || this._getUserImage(item.id);
                            },
                            getDisplayName: (): string => {
                                return item.displayName;
                            }
                        }}
                        size={this.props.avatarSize ? this.props.avatarSize : "large"}
                    />
                    <div className="left-margin">
                        <div className="fontWeightSemiBold">{item.displayName}</div>
                        <div className="grey-font">{item.preferredEmailAddress}</div>
                    </div>
                    {this.props.canDeleteMember && (
                        <Button
                            className="left-margin delete-button"
                            subtle={true}
                            iconProps={{ iconName: "Delete" }}
                            onClick={() => this.props.onDeleteMember!(item as ICustomIdentityRef)}
                        />
                    )}
                </div>
            </ListItem>
        );
    };

    private _getUserImage(userId: string) {
        const url = getIdentityImageUrl(this.props.pageContext || this.context.pageContext, userId);
        return url;
    }
}

VssComponent.register("ms.vss-admin-web.users-list-component", UsersListComponent);
